import { memo } from 'react';
import { UserInput } from 'src/actuators/user-input/types';
import { LocalesEnum, RegionsEnum } from 'src/generated/operations';
import { prepareUserInputFormValues } from 'src/actuators/common/prepareUserInputFormValues.ts';
import { useBelimoTranslate } from 'src/common/hooks/useBelimoTranslate.ts';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';

type Props = {
    region: RegionsEnum;
    state: UserInput;
    isLinear: boolean;
    currentLocale: LocalesEnum;
}

export const ActuatorTooltipValue = memo(({ region, state, isLinear, currentLocale }: Props) => {
    const translate = useBelimoTranslate();
    return (
        <div className="vss-actuator-tooltip-value">
            {prepareUserInputFormValues({
                userInput: state,
                currentRegion: region,
                translate,
                isLinear,
                currentLocale,
            }).map(([label, value, unit]) => (
                <div key={label} className="vss-actuator-tooltip-value__row">
                    <p className="vss-actuator-tooltip-value__label">
                        <I18n messageId={label}/>
                    </p>
                    <p
                        className="vss-actuator-tooltip-value__value"
                    >{value}{unit.length ? ([' ', <I18n messageId={unit}/>]) : ''}
                    </p>
                </div>
            ))}
        </div>
    );
});
